module.exports = __webpack_public_path__ + "media/flags/fk-4c73d045.svg";